import React, { FC, useEffect, useState, useContext, memo, useCallback } from 'react';

import { DedicatedRouteProps } from 'home/view/check-feasibility/comp-generator/common-interface';
import { getCurrentLead } from 'tokenGeneration/lead.util';

import OrderDetailsAccordion from './OrderDetailsAccordion';
import InstallationDetailsAccordion from './InstallationDetailsAccordion';

import { AppContext } from 'App';

import './index.scss';
import { findParamFromUrl, isAuthForDev, isDevEnv, isSingleUpgradeOrShiftingJourney } from 'common/utils/app.utils';
import { ROUTES, isShiftingJourney } from 'common/constants/app.constants';

export const LandingPageAOI: FC<DedicatedRouteProps> = (props) => {
  const { setSelectedRadio } = useContext<any>(AppContext);
  const [showInstallationDetailsAccordion, setShowInstallationDetailsAccordion] = useState<boolean>(false);
  const partyId = findParamFromUrl('partyId', false);

  const renderInstallationDetailsAccordion = () => {
    // setShowInstallationDetailsAccordion(true);

    const currentLead = getCurrentLead();
    const isAOIJourney = currentLead.serviceType === 'DSL';

    let redirectUrl = ROUTES.AOI.DEDICATED_BULK_FEASIBILITY;

    

    if (isDevEnv() && isAuthForDev()) {
      redirectUrl = redirectUrl + '?isAuth=' + findParamFromUrl('isAuth', false);
    }
    if (partyId) {
      if(isDevEnv() && isAuthForDev()){
        redirectUrl = redirectUrl + '&partyId=' + partyId;
      } else{
        redirectUrl = redirectUrl + '?partyId=' + partyId;
      }
      
    }

    props.history.push(redirectUrl);
  };

  const handleSiteTypeRadioUpdate = (formData: any) => {
    if (formData) {
      const selectedRadioValue = formData['siteType'];
      setSelectedRadio(selectedRadioValue);
    }
  };

  const onLeadSuccessCb = useCallback((formData: any): void => {
    handleSiteTypeRadioUpdate(formData);
    renderInstallationDetailsAccordion();
  }, []);

  const onFormLoadCb = useCallback((formData: any): void => {
    handleSiteTypeRadioUpdate(formData);
  }, []);

  useEffect(() => {
    if (getCurrentLead() && (!isSingleUpgradeOrShiftingJourney() || !isShiftingJourney())) {
      renderInstallationDetailsAccordion();
    }
  }, []);

  return (
    <div className="landing-page">
      <OrderDetailsAccordion onFormLoad={onFormLoadCb} onLeadSuccessCb={onLeadSuccessCb} {...props} />
      {/* <div className="installation_section">{showInstallationDetailsAccordion && <InstallationDetailsAccordion {...props} />}</div> */}
    </div>
  );
};

export default memo(LandingPageAOI);
